import * as React from 'react';
import Box from '@mui/material/Box';
import {
  DataGrid,
  GridColDef,
  GridRowId,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { Photo } from '../types';
import { getPhotos } from '../api';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'Nom', width: 400 },
  {
    field: 'photo_name',
    headerName: 'Photo',
    renderCell: ((params: GridValueGetterParams) => {
      return <img src={"https://keldom.blob.core.windows.net/domemploi/job/logo/mini/" + params.value} style={{ width: 100 }} />;
    }) as any,
  },
];

export function PhotoDataGrid({
  currentCustomerId,
  setSelectedClient,
}: {
  currentCustomerId?: number;
  setSelectedClient: Function;
}) {
  const [photos, setPhotos] = React.useState([] as Photo[]);
  React.useEffect(() => {
    const main = async () => {
      const allPhotos = await getPhotos();
      allPhotos.forEach((p) => (p.id = p.photo_name));
      setPhotos(allPhotos);
    };
    main();
  }, []);

  const [search, setSearch] = React.useState('');

  const photosToDisplay = photos.filter((c) =>
    String(c.photo_name).toLowerCase().includes(search.toLowerCase()),
  );
  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>(
    currentCustomerId ? [String(currentCustomerId)] : [],
  );

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <p>Photo initialement sur l'offre DE : {currentCustomerId}</p>
      {selectionModel[0] !== String(currentCustomerId) && (
        <p>
          Changement de la photo de l'offre DE pour :{' '}
          {selectionModel[0]}
        </p>
      )}
      <TextField
        id="search-customer"
        label="Rechercher une photo"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <DataGrid
        key={photosToDisplay.length}
        rows={photosToDisplay}
        columns={columns}
        checkboxSelection={true}
        rowSelectionModel={selectionModel}
        disableRowSelectionOnClick
        onRowSelectionModelChange={(selection) => {
          if (selection.length === 1) {
            setSelectionModel(selection);
            setSelectedClient(selection[0]);
          }
          if (selection.length > 1) {
            const selectionSet = new Set(selectionModel);
            const result = selection.filter((s) => !selectionSet.has(s));
            setSelectionModel(result);
            setSelectedClient(result[0]);
          }
        }}
      />
    </Box>
  );
}
